import { useTranslation } from 'react-i18next';

import VideoModal from '../VideoModal/VideoModal';
import { getPosterframe, getImageUrl } from '@/utils/dedaloUtils';
import { splitTerm } from '@/utils/splitTerm';
import { shortenText } from '@/utils/shortenText';

function Audiovisuals({ videos }) {
    const { t } = useTranslation();

    return (
        <div className="has-background-light p-7 radius flow">
            <h3>{t('audiovisuales')}</h3>
            <div className="py-5">
                <ul className="audiovisuals-gallery list-reset">
                    {videos &&
                        videos.length > 0 &&
                        videos.map((item, i) => {
                            const { primary, secondary } = splitTerm(item.title);

                            return (
                                <li key={'audiovisual-' + i}>
                                    <VideoModal title={item.title} video={getImageUrl(item.video)}>
                                        <img
                                            src={getPosterframe(item.video)}
                                            alt={item.title}
                                            className="radius"
                                        />
                                        <div>
                                            <p>
                                                <strong>{primary}</strong>
                                            </p>
                                            <p className="is-size-6 has-text-weight-light">
                                                {secondary || shortenText(item.fragm, 100)}
                                            </p>
                                        </div>
                                    </VideoModal>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
}

export default Audiovisuals;
